import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import BaseComponent from '../../../baseClasses/BaseComponent';
import animator from '../../../helpers/animator';
import UserAvatar from '../../../components/UserAvatar';
import LocationDropDown from '../../ProjectsContainer/ProjectHierarchy/SubHeader/LocationDropDown';
import PDFGenerator from '../../../components/PDFGenerator';
import dataModel from '../../../models/DataModel';
import Home from '../../Home';
import AnalyticsLogger from '../../../helpers/analytics/analyticsLogger';
import DelaysDropDown from '../../../components/DelaysDropDown';
import assignIcon from '../../../assets/images/assign.svg';
import closeoutIcon from '../../../assets/images/document-scroll-small.svg';
import inventoryIcon from '../../../assets/images/inventory.svg';
import porIcon from '../../../assets/images/por.svg';
import mapIcon from '../../../assets/images/view-on-map.svg';

import progressReportIcon from '../../../assets/images/pdf-export-icon-gray.svg';
import SelectProjectMemberPopup from '../../ProjectsContainer/ProjectCRUD/SelectProjectMemberPopup';
import ReplaceProjectMemberPopup from '../../ProjectsContainer/ProjectCRUD/ReplaceProjectMemberPopup';
import ShowProjectMemberInfoPopup from '../../ProjectsContainer/ProjectCRUD/ShowProjectMemberInfoPopup';
import CommentsDropDown from '../../ProjectsContainer/ProjectHierarchy/SubHeader/CommentsDropDown';
import Inventory from '../../../components/Inventory';
import KeyMemberDisplay from '../../../components/KeyMemberDisplay';
import * as BuildOwnerPermissionsUtil from '../../../helpers/permissions/BuildOwnerPermissionsUtil';
import { build_root } from '../../../dao/BuildsDAO';
import DataSource from '../../../dao/DataSource/DataSource';
import { attributes_project_template_root } from '../../../dao/ProjectTemplatesDAO';

import delaysActiveIcon from '../../../assets/images/delays-icon-active.svg';
import delaysInactiveIcon from '../../../assets/images/delays-icon-inactive.svg';
import DateRangePickerModal from '../../../components/DateRangePickerModal/DateRangePickerModal';
import progressReportsService from '../../../services/progressReportsService';
import ProjectTemplateLink from './ProjectTemplateLink';
import './ProjectHeader.scss';

const user_partial = {
  additionalFields: ['profile_image'], role: { }, companies: { }, 
};
const project_root = {
  project: {
    project_manager: {},
    project_template: {},
    project_users: { user: user_partial },
    users: user_partial,
    location: { location_users: { user: {} } },
    project_contacts: { user: {} },
    all_locations: { location_users: { user: {} } },
    builds: { builds: {} },
  },
};

var slideInTime = 100;
export class ProjectHeader extends BaseComponent {

  constructor(props) {
    super(props);
    this.animator = new animator();
    this.animate = false;
    this.currentDropDownSize = 290;
    this.closeOtherAndOpenNewDropDown = this.closeOtherAndOpenNewDropDown.bind(this);
    this.createMemberPopup = this.createMemberPopup.bind(this);
    this.state = { 
      selectedUser: null, 
      displayDropDown: '', 
      displayedUserInfo: null,
      delayDropdownDisplay: null,
      displayDelayId: null,
      isBuildOwner: null,
      project: this.props.project || null,
      showProgressReportModal: false,
      progressReportDateRange: null,
    };
    this.cachedDropDownDisplay = '';

    const { currentUser } = props;
    const { primary_company_id, current_company_id } = localStorage;
    if (
      currentUser.super_admin ||
      (currentUser.role_name == 'admin' && primary_company_id == current_company_id)
    ) {
      this.userCanViewAllDelays = true;
    }

    this.closeOtherAndOpenNewDropDown = this.closeOtherAndOpenNewDropDown.bind(this);
    this.openNewDropDown = this.openNewDropDown.bind(this);
    this.closeDropDown = this.closeDropDown.bind(this);

    const currentRole = currentUser ? currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: !!window.cordova,
    });
  }

  handleProjectRetrieval(project, action, acData, fetchedData) {
    const hasTemplateId = project && (project.project_template_id != null && project.project_template_id !== '');
    const missingTemplate = hasTemplateId && (!project.project_template || !project.project_template.id);
    if (missingTemplate) {
      dataModel.projectTemplatesDAO.getProjectTemplate(project.project_template_id, { recordDescriptor: attributes_project_template_root })
        .then((template) => {
          if (template && this.setState) {
            this.setState({
              project: { ...project, project_template: template },
              isBuildOwner: this.props.type != 'summary-page' ? BuildOwnerPermissionsUtil.isBuildOwnerInProject(project, this.props.currentUser) : null,
              updateInventory: this.state.displayDropDown == 'inventoryDisplay' ? true : false,
            });
          }
        })
        .catch(() => {
          this.setState({
            project,
            isBuildOwner: this.props.type != 'summary-page' ? BuildOwnerPermissionsUtil.isBuildOwnerInProject(project, this.props.currentUser) : null,
            updateInventory: this.state.displayDropDown == 'inventoryDisplay' ? true : false,
          });
        });
      return;
    }
    this.setState({
      project,
      isBuildOwner: this.props.type != 'summary-page' ? BuildOwnerPermissionsUtil.isBuildOwnerInProject(project, this.props.currentUser) : null,
      updateInventory: this.state.displayDropDown == 'inventoryDisplay' ? true : false,
    });
  }

  handleBuildRetrieval(build, action, acData, fetchedData) {
    this.setState({ build });
  }

  handleInitializeDataSources() {
    const { build, task, projectId } = this.props;
    if (this.projectDataSource) {
      this.projectDataSource.release();
    }
    if (this.buildDataSource) {
      this.buildDataSource.release();
    }

    if (projectId) {
      this.projectDataSource = new DataSource('Project', projectId, project_root, this.handleProjectRetrieval, null, null, null, true);
      this.projectDataSource.get();
    }
    if (!build || build == -1) {
      if (task) {
        this.buildDataSource = new DataSource('Build', task.build_id, build_root, this.handleBuildRetrieval, null, null, null, true);
        this.buildDataSource.get();
      }
    }
    else if (build) {
      this.buildDataSource = new DataSource('Build', build.id, build_root, this.handleBuildRetrieval, null, null, null, true);
      this.buildDataSource.get();
    }
  }

  componentDidMount() {

    this.handleInitializeDataSources();
    
    const { mapExpanded, mapType, handleExpansion } = this.props;
    if (mapExpanded && mapType == 'inventoryDisplay') {
      this.setState({ displayDropDown: 'inventoryDisplay' });
      handleExpansion((window.innerHeight - 132), 'inventoryDisplay');
    }
    else if (mapExpanded) {
      this.setState({ displayDropDown: 'mapDisplay' });
      handleExpansion(290, 'mapDisplay');
    }

    const { history } = this.props;
    this.unlisten = history.listen(() => {
      this.closeDropDown('mapDisplay');
    });
  }

  componentWillUnmount() {
    if (this.projectDataSource) {
      this.projectDataSource.release();
      this.projectDataSource = null;
    }
    if (this.buildDataSource) {
      this.buildDataSource.release();
      this.buildDataSource = null;
    }
    this.unlisten();
  }

  componentDidUpdate(prevProps) {
    const nextProps = this.props;

    // The parent may already hold the fetched project (ProjectHierarchy does) while our own
    // store-only read found nothing yet, which left render() bailing on !state.project and the
    // header strip blank. Fill from the prop ONLY when we have nothing: this never overwrites a
    // project the data source supplied, and the constructor already seeds from the same prop, so
    // parents that pass one on mount are unaffected. handleProjectRetrieval still overwrites this
    // with the fuller record (including project_template) when it arrives.
    if (!this.state.project && nextProps.project) {
      this.setState({
        project: nextProps.project,
        isBuildOwner: nextProps.type != 'summary-page' ? BuildOwnerPermissionsUtil.isBuildOwnerInProject(nextProps.project, nextProps.currentUser) : null,
      });
    }

    if (prevProps.projectId != nextProps.projectId) {
      this.handleInitializeDataSources();
    }
    else if ((!prevProps.build && nextProps.build) || (prevProps.build && nextProps.build && prevProps.build.id != nextProps.build.id)) {
      this.handleInitializeDataSources();
    }
    else if (prevProps.displayDelayId != this.props.displayDelayId) {
      this.setState({ displayDelayId: this.props.displayDelayId }, () => {
        if (this.state.displayDelayId) {
          this.handleDelayDropdownDisplay();
        }
      });
    }
  }

  get build() {
    return this.state.build ? this.state.build : this.props.build;
  }

  /** PROJECT MEMEBER FUNCTIONS */

  //TODO: Clean up these functions
    //get rid of xPos/yPos, move popups to child components
    //they should be positioned relative to the avatar, not this component
    //no more document.getElementById(..)
  handleAddMember(e) {
    let { project } = this.state;
    e.stopPropagation();
    if (this.state.displayAddMember) {
      this.setState({ closeProjectMemberPopup: true });
    } 
    else {
      const userElement = document.getElementById('add-member-button');
      let x = 0;
      let y = 0;
      if (userElement) {
        const rect = userElement.getBoundingClientRect();
        let parent = document.querySelector('[id^=\'project-header\']');
        if (parent) {
          const parentRect = parent.getBoundingClientRect();
          x = rect.left - parentRect.left - 178;
          y = rect.top - parentRect.top + rect.height + 15;
        } else {
          x = rect.left - 178;
          y = rect.top + rect.height + 20;
        }
      }
      this.setState({
        closeProjectMemberPopup: false,
        displayAddMember: true,
        xPos: x,
        yPos: y,
        displayEditMember: false,
      });
    }
  }

  handleSelectUser(user, e) {
    let { project } = this.state;
    e.stopPropagation();
    const { permissions } = this.props;
    if (
      this.state.displayEditMember &&
      this.state.selectedUser &&
      user.id == this.state.selectedUser.id
    ) {
      this.setState({ displayEditMember: false });
    } else if (permissions && (permissions.canEditProject || permissions.canAddProjectMembers)) {
      const userElement = document.getElementById(
        'project-user-avatar-header-' + user.id
      );
      let x = 0;
      let y = 0;
      if (userElement) {
        const rect = userElement.getBoundingClientRect();
        let parent = document.getElementById(`project-header-${project && project.id}`);
        if (parent) {
          const parentRect = parent.getBoundingClientRect();
          x = rect.left - parentRect.left - 114;
          y = parentRect.top;
          if (y + 334 > window.innerHeight) {
            y = parentRect.top - 334;
          }
          if (x + 334 + parentRect.left > window.innerWidth) {
            x = x - 334;
          }
        }
      }
      this.setState({
        displayEditMember: true,
        xPos: x,
        yPos: y,
        closeProjectMemberPopup: true,
        selectedUser: user,
      });
    } else {
      const userElement = document.getElementById(
        'project-user-avatar-header-' + user.id
      );
      let x = 0;
      let y = 0;
      if (userElement) {
        const rect = userElement.getBoundingClientRect();
        let parent = document.getElementById(`project-header-${project && project.id}`);
        if (parent) {
          const parentRect = parent.getBoundingClientRect();
          x = rect.left - parentRect.left - 118;
          y = rect.top - parentRect.top + rect.height + 16;
        }
      }
      this.setState({
        displayInfoMember: true,
        xPos: x,
        yPos: y,
        closeProjectMemberPopup: true,
        selectedUser: user,
      });
    }
  }

  handleAddUsersClose() {
    this.setState({
      closeProjectMemberPopup: false,
      displayAddMember: false,
      displayEditMember: false,
      displayInfoMember: false,
    });
  }

  handleReplaceUser(user) {
    if (user) {
      if (this.state.selectedUser && this.state.selectedUser.id == user.id) {
        dataModel.displayWarnErrorMessage(
          'You cannot select the same user...',
          4000,
          2
        );
      } else {
        if (user) {
          this.analyticsLogger.logProjectMemberReplace();
          this.projectDataSource.performAction('replaceProjectMember', this.state.project,  user, this.state.selectedUser);
        }
      }
      this.setState({ displayEditMember: false });
    }
  }

  /** DROPDOWN FUNCTIONS */
  handleMapRequest() {
    const { displayDropDown } = this.state;
    if (this.props.handleExpansion){
      if (displayDropDown != '') {
        this.closeOtherAndOpenNewDropDown('mapDisplay', 290, true);
      }
      else {
        this.analyticsLogger.logMaps('ViewOnMap');
        this.openNewDropDown('mapDisplay', 290, true);
      }
    }
  }

  handleCommentsRequest() {
    const { displayDropDown } = this.state;
    if (this.props.handleExpansion) {
      if (displayDropDown != '') {
        this.closeOtherAndOpenNewDropDown('commentsDisplay', 167, true);
      } else {
        this.openNewDropDown('commentsDisplay', 167, true);
      }
    }
  }

  handleInventoryRequest() {
    const { displayDropDown } = this.state;
    if (displayDropDown != 'inventoryDisplay') {
      // expanding/opening inventory table
      this.analyticsLogger.logInventoryEvent('InventoryReportingAccess');
    }
    if (this.props.handleExpansion) {
      if (displayDropDown != '') {
        this.closeOtherAndOpenNewDropDown('inventoryDisplay', (window.innerHeight - 132), true);
      }
      else {
        this.openNewDropDown('inventoryDisplay', (window.innerHeight - 132), true);
      }
    }
  }

  handleCloseDropdown(e) {
    if (this.props.handleExpansion) {
      switch (this.state.displayDropDown) {
      case 'mapDisplay':
        this.closeDropDown('mapDisplay');
        break;
      case 'commentsDisplay':
        this.handleCommentsRequest();
        break;
      case 'inventoryDisplay':
        this.handleInventoryRequest();
        break;
      default:
        break;
      }
      this.props.handleExpansion(0);
    }
  }

  openNewDropDown(displayDropDown, size, animate) {
    if (displayDropDown == 'mapDisplay') {
      this.props.handleExpansion(273, 'mapDisplay');
    } else if (displayDropDown == 'commentsDisplay') {
      this.props.handleExpansion(150);
    } else if (displayDropDown == 'inventoryDisplay') {
      this.props.handleExpansion((window.innerHeight - 132), 'inventoryDisplay');
    }

    this.animate = true;
    this.currentDropDownSize = size;
    this.setState({ displayDropDown: displayDropDown });
  }

  closeOtherAndOpenNewDropDown(newDisplayDropDown, newSize, animate) {
    const { displayDropDown } = this.state;
    if (newDisplayDropDown != displayDropDown) {
      this.cachedDropDownDisplay = null;
      const { handleExpand } = this.props;
      if (handleExpand) {
        handleExpand(0);
        this.cachedDropDownDisplay = null;
      }
      this.openNewDropDown(newDisplayDropDown, newSize, animate);
    }
  }

  closeDropDown(newDisplayDropDown) {
    const { displayDropDown } = this.state;
    if (newDisplayDropDown === displayDropDown) {
      this.setState({ displayDropDown: '' });
      this.cachedDropDownDisplay = null;
      this.props.handleExpansion(0);
    }
  }

  animateMe(id, finalHeight, expandContainer) {
    this.animating = true;
    const animationGroup = [];
    if (expandContainer) {
      const { handleExpand } = this.props;
      if (handleExpand) {
        handleExpand(finalHeight, animationGroup, slideInTime * 2 / 3);
      }
    }
    let ani = this.animator.createPropertyAnimation(id, slideInTime * 2/3, { height: { startVal: 0, endVal: finalHeight } });
    animationGroup.push(ani);
    this.animator.addCollection(animationGroup, false);
    setTimeout(() => {
      this.animator.processAnimationQueue(() => {
        this.animating = false;
        if (expandContainer) {
          const { handleExpand } = this.props;
          if (handleExpand) {
            handleExpand(finalHeight);
          }
        }
        else {
          this.hoverDownHasDisplayed = true;
        }
      });
    }, 30);
  }

  /** GENERAL CLICK HANDLERS */
  handleStartLoader(){
    this.setState({ loader: true });
  }

  handleEndLoader(){
    this.setState({ loader: false });
  }

  handleInfoOpen(assignment) {
    this.setState({ displayedUserInfo: assignment });
  }

  handleInfoClose() {
    this.setState({ displayedUserInfo: null });
  }

  handleCloseDelayDropdownDisplay() {
    this.cachedDropDownDisplay = null;
    if (this.state.displayDelayId) {
      this.setState({ displayDelayId: null }, () => {
        this.handleDelayDropdownDisplay();
      });
    } else {
      this.handleDelayDropdownDisplay();
    }
  }

  handleDelayDropdownDisplay(e) {
    if (e) e.stopPropagation();
    const { type } = this.props;
    let { project } = this.state;
    
    if (!project) {
      return null;
    }

    if (project.has_unread_alerts) {
      dataModel.AlertsDAO.markAllReadByProjectId(project.id);
    }
    else if (project.has_alerts || (project.has_delays && this.userCanViewAllDelays)) {
      this.analyticsLogger.logDelayEvent(type == 'summary-page' ? 'DelayViewedProjectSummary' : 'DelayViewedProjectHeader');
    }

    if (this.state.delayDropdownDisplay && !this.state.displayDelayId) {
      this.setState({ delayDropdownDisplay: null });
      if (this.props.closedDelay) {
        this.props.closedDelay();
      }
    }
    else {
      const targetRect = this.delayIndicator.getBoundingClientRect();
      let top = targetRect.top;
      if (top + 400 > window.innerHeight) {
        top = window.innerHeight - 410; //400 is height of delays popout, 10 is extra padding
      }
      const delaysDropdownInfo = { top, left: targetRect.left };
      this.setState({ delayDropdownDisplay: delaysDropdownInfo });
    }
  }

  /** RENDER FUNCTIONS */
  createMapDisplay(animate) {
    const { myProjects } = this.props;
    let { project } = this.state;
    
    if (!project) {
      return null;
    }
    const locationDropDown = (
      <LocationDropDown 
        key={this.props.allProjects ? 'all-projects' :  project ? project.id : Math.floor(20 * Math.random())} 
        allProjects={this.props.allProjects} 
        myProjects={myProjects}
        project={project} 
        all_locations={project.all_locations && project.all_locations.length > 1? project.all_locations: null}
        height={animate ? 0 : 290} 
        handleCloseDropDown={this.handleCloseDropdown}
      />
    );
    if (locationDropDown) {
      if (!animate) {
        const { handleExpand } = this.props;
        if (handleExpand) {
          handleExpand(290);
        }
      }
      else {
        this.animateMe('mapDisplay', 290, true);
      }
    }

    return locationDropDown;
  }

  createMemberArray() {
    const { permissions } = this.props;
    let { project } = this.state;
    
    if (!project) {
      return null;
    }
    const dontAllowAdd = this.props.dontAllowAdd || !((permissions && permissions.canAddProjectMembers) || this.state.isBuildOwner);
    if (project.users) {
      return project.users.map((user, index) => {
        if (user) {
          const selected = this.state.selectedUser && user.id == this.state.selectedUser.id && !dontAllowAdd;
          return (
            <UserAvatar id={'project-user-avatar-header-' + user.id} 
              key={'project-user-avatar-header-' + user.id + index} 
              user={user}
              selected={selected}
              handleSelected={!dontAllowAdd ? this.handleSelectUser : null} 
              handleMenuSelection={!dontAllowAdd ? this.handleMemberMenuSelection : null} 
            />
          );
        }
        else {
          return null;
        }
      });
    }
    else {
      return null;
    }
  }

  createNotesDisplay(animate) {
    const { build, task } = this.props;
    const { project } = this.state;
    const notesDropDown = (
      <CommentsDropDown
        project={build ? null : project}
        build={build}
        task={task}
        height={animate ? 0 : 167}
        handleCloseDropDown={this.handleCloseDropdown}
      />
    );

    if (!animate) {
      const { handleExpand } = this.props;
      if (handleExpand) {
        handleExpand(167);
      }
    } else {
      this.animateMe('commentsDisplay', 167, true);
    }

    return notesDropDown;
  }

  createInventoryDisplay(animate) {
    const accent = this.props.currentCompany.accent_color;
    const inventoryDropDown = (
      <Inventory 
        accent={ accent } 
        project={ this.state.project } 
        height={animate ? 0 : (window.innerHeight - 132)}
        updateInventory={ this.state.updateInventory }
      />
    );
    if (inventoryDropDown) {
      if (!animate) {
        const { handleExpand } = this.props;
        if (handleExpand) {
          handleExpand((window.innerHeight - 132));
        }
      } else {
        this.animateMe('inventoryDisplay', (window.innerHeight - 132), true);
      }
    }

    this.setState({ updateInventory: false });
  
    return inventoryDropDown;
  }

  createBuildOwnerMemberPopup() {
    const { currentUser } = this.props;
    let { project, build } = this.state;
    
    if (!project) {
      return null;
    }
    const { 
      yPos,
      xPos,
      selectedUser,
    } = this.state;

    let isBuildOwner = false;
    if (build && typeof build == 'object') {
      // if !build.ancestry, the it's the root build (project)
      isBuildOwner = !build.ancestry ? this.state.isBuildOwner : build.build_owners && build.build_owners.filter(bowner => { return bowner.id == currentUser.id; });
      isBuildOwner = isBuildOwner == true || (isBuildOwner && isBuildOwner.length > 0);
    }
    //if the selected user is in the same company of the build owner
    if (project.company_id != selectedUser.companies[0].id) {
      //if the current user is in project view or a build view that is not the build they own
      if (!build || (build && !isBuildOwner)) {
        return (
          <ShowProjectMemberInfoPopup
            key={ selectedUser ? selectedUser.id : Math.random()}
            top={yPos}
            left={xPos}
            user={selectedUser}
            isBuildOwner={true}
          />
        );    
      } 
      //if current user is build owner of the project, AND build owner of the current build view
      else if (build && !build.length && isBuildOwner) {
        //if the selected user is in the same company of the build owner AND BUILD OWNER IS IN BUILD VIEW
        return (
          <ReplaceProjectMemberPopup
            key={ selectedUser ? selectedUser.id : Math.random() }
            replaceMember={this.handleReplaceUser}
            selectedUser={selectedUser}
            handlePopupClose={this.handleAddUsersClose}
            project={project}
            top={yPos}
            left={xPos}
            multiSelect={false}
            type="replace"
            isBuildOwner={true}
            handleDisplayQuickerAssign={this.handleDisplayQuickerAssign}
            handleBuildOwnerTaskSave={this.props.handleBuildOwnerTaskSave}
          />
        );
      } 
    } 
    //if the selected user is not in the same company of the build owner show this ALWAYS
    else {
      return (
          <ShowProjectMemberInfoPopup
            key={ selectedUser ? selectedUser.id : Math.random() }
            top={yPos}
            left={xPos}
            user={selectedUser}
          />
        );        
    } 
  }

  createMemberPopup() {
    const { currentUser, currentCompany } = this.props;
    let { project } = this.state;
    
    if (!project) {
      return null;
    }
    const { 
      displayAddMember, 
      displayEditMember, 
      displayInfoMember,
      closeProjectMemberPopup,
      yPos,
      xPos,
      selectedUser,
      isBuildOwner,
    } = this.state;
    
    let addMemberPopup = null;

    //if current user is a build owner on the project, create build owner member specific popups
    //these specifically display when the primary company is NOT the user's current company
    if (displayInfoMember 
        && isBuildOwner
        && BuildOwnerPermissionsUtil.isBuildOwnerInVendorCompany(currentCompany, currentUser)
    ) {
      addMemberPopup = this.createBuildOwnerMemberPopup();
    } else {
      if (displayAddMember && project) {
        addMemberPopup = (
          <SelectProjectMemberPopup
            handlePopupClose={this.handleAddUsersClose}
            requestClose={closeProjectMemberPopup}
            project={project}
            top={yPos}
            left={xPos}
            multiSelect={true}
            type="add"
            isBuildOwner={isBuildOwner}
            updateProject={this.props.updateProject}
          />
        );
      } else if (displayEditMember && project) {
        addMemberPopup = (
          <ReplaceProjectMemberPopup
            key={ selectedUser ? selectedUser.id : Math.random() }
            replaceMember={this.handleReplaceUser}
            selectedUser={selectedUser}
            handlePopupClose={this.handleAddUsersClose}
            project={project}
            top={yPos}
            left={xPos}
            multiSelect={false}
            handleDisplayQuickerAssign={this.handleDisplayQuickerAssign}
            type="replace"
          />
        );
      } else if (displayInfoMember && project) {
        addMemberPopup = (
          <ShowProjectMemberInfoPopup
            key={ selectedUser ? selectedUser.id : Math.random()}
            top={yPos}
            left={xPos}
            user={selectedUser}
          />
        );
      }
    }

    //if build view and build owner is build owner of the build
    //only show the thing if there is ONE build and the build owner of the build equals the current user
    return addMemberPopup;
  }

  handleProjectNameClick(){
    if (this.state.project) {
      this.props.history.replace('/por/project/' + this.state.project.id + '/location/all?tab=documents&navigation=skip_select');
    }
  }

  handleNavigateToProject() {
    if (this.state) {
      this.props.history.replace(`/projects/${this.state.project.id}`);
    }
  }

  handleCloseoutStarted() {
    // No-op - closeout started
  }

  isAssignAllowed() {
    const { currentUser, currentCompany, isBuildOwner, permissions } = this.props;
    
    if (isBuildOwner
      && BuildOwnerPermissionsUtil.isBuildOwnerInVendorCompany(currentCompany, currentUser)) {
      return true;
    }
    else if (!currentCompany.admin_company && permissions.canAddProjectMembers && currentUser.companies[0].id == currentCompany.id) {
      return true;
    }
    else if (permissions.isSuperUser) { 
      return true;
    }
    return false;
  }

  handleOpenProgressReportModal() {
    this.setState({ showProgressReportModal: true });
  }

  handleCloseProgressReportModal() {
    this.setState({ showProgressReportModal: false });
  }

  handleProgressReportGenerate(dateRange) {
    const { project } = this.state;
    
    if (!project || !project.id) {
      dataModel.displayWarnErrorMessage('No project selected', 3000, 2);
      return;
    }

    if (!dateRange.startDate || !dateRange.endDate) {
      dataModel.displayWarnErrorMessage('Please select both start and end dates', 3000, 2);
      return;
    }

    this.setState({ 
      progressReportDateRange: dateRange,
      showProgressReportModal: false, 
    });

    progressReportsService.createProgressReport({
      project_id: project.id,
      start_date: dateRange.startDate,
      end_date: dateRange.endDate,
    }).then(response => {
      if (response.error) {
        dataModel.displayHTTPError('Error generating progress report', response.error, false);
      } else {
        dataModel.displayInfoErrorMessage('Progress report generation started. You will be notified when it is ready.', 4000, 1);
      }
    }).catch(error => {
      dataModel.displayHTTPError('Error generating progress report', error, false);
    });
  }

  handleDisplayQuickerAssign(project, user) {
    const { currentCompany, currentUser } = this.props;
    const { isBuildOwner } = this.state;
    if (this.props.displayQuickerAssign) {
      let isVendorBuildOwner = false;
      if (isBuildOwner
        && BuildOwnerPermissionsUtil.isBuildOwnerInVendorCompany(currentCompany, currentUser)) {
        isVendorBuildOwner = true;
      }
  
      this.props.displayQuickerAssign(this.state.project, isVendorBuildOwner, user);
    }
  }

  handleMenuSelection(type) {
    switch (type) {
    case 'assign':
      this.handleDisplayQuickerAssign(this.state.project);
      break;
    case 'closout':
      break;
    case 'inventory':
      this.handleInventoryRequest();
      break;
    case 'planOfRecord':
      if (this.state.project) {
        this.props.history.replace('/por/project/' + this.state.project.id + '/location/all?tab=documents&navigation=skip_select');
      }
      break;
    case 'map':
      this.handleMapRequest();
      break;
    default:
      break;
    }
  }

  createNavButtons() {
    const assignAllowed = this.isAssignAllowed();
    const pdfClasses = 'text-button pdf-export-button';
    
    return (
      <div className="project-header-nav">
        {assignAllowed && (
          <div 
            className="nav-icon-button" 
            onClick={() => this.handleMenuSelection('assign')}
            data-tooltip="Assign"
          >
            <img src={assignIcon} alt="Assign" />
          </div>
        )}
        <div 
          className="nav-icon-button" 
          onClick={this.handleOpenProgressReportModal}
          data-tooltip="Progress Report"
        >
          <img src={progressReportIcon} alt="Progress Report" />
        </div>
        <div className="nav-icon-button" data-tooltip="Closeout Package">
          <PDFGenerator 
            class={pdfClasses} 
            build={this.build} 
            project={this.state.project} 
            task={this.props.task}
            closeoutStarted={this.handleCloseoutStarted}
            closeout_client_data={{ destination: 'POR' }}
            icon={<img src={closeoutIcon} alt="Closeout Package" />}
          />
        </div>
        <div 
          className="nav-icon-button" 
          onClick={() => this.handleMenuSelection('inventory')}
          data-tooltip="Inventory"
        >
          <img src={inventoryIcon} alt="Inventory" />
        </div>
        <div 
          className="nav-icon-button" 
          onClick={() => this.handleMenuSelection('planOfRecord')}
          data-tooltip="Plan of Record"
        >
          <img src={porIcon} alt="Plan of Record" />
        </div>
        <div 
          className="nav-icon-button" 
          onClick={() => this.handleMenuSelection('map')}
          data-tooltip="View on Map"
        >
          <img src={mapIcon} alt="View on Map" />
        </div>
      </div>
    );
  }

  render() {
    // TODO: major cleanup here
    const {
      permissions,
      currentCompany,
      inProjectsTab,
      isLeftDividerHide,
      currentUser,
    } = this.props;

    let { project } = this.state;
    
    if (!project) {
      return null;
    }

    const { displayDropDown, delayDropdownDisplay } = this.state;
    const currentUserIsAdmin = currentUser.role_name == 'admin' || currentUser.role_name == 'super_user';

    let memberSelector = null;
    if (!currentCompany.admin_company && inProjectsTab && project) {
      const memberImages = this.createMemberArray();
      let addButton = null;
      if (
        !this.props.dontAllowAdd &&
        ((permissions && permissions.canAddProjectMembers) || this.state.isBuildOwner) &&
        !project.archived_at
      ) {
        addButton = (
          <div
            className="add-member-button"
            id="add-member-button"
            onClick={
              (permissions && permissions.canAddProjectMembers) || this.state.isBuildOwner
                ? this.handleAddMember
                : null
            }
          >
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </div>
        );
      }
      memberSelector =
        <div className="project-control">
          <div className="member-selection">
            <div className="label">
              {this.textMap.members.toUpperCase()}
            </div>
            <div className="member-container">
              {addButton}
              <div
                className="member-array"
                onScroll={(e) => { e.stopPropagation(); }}
              >
                {memberImages}
              </div>
            </div>
          </div>
        </div>;
    }

    let addMemberPopup = this.createMemberPopup();

    let  controls = (
      <div className="project-controls">
{!this.props.allProjects && project && !this.props.useSummaryDataOnly &&
                  <KeyMemberDisplay
                    project={project}
                    build={this.props.build}
                    displayedUserInfo={this.state.displayedUserInfo}
                    handleInfoOpen={this.handleInfoOpen}
                    handleInfoClose={this.handleInfoClose}
                    locationUsers={project && project.location ? project.location.location_users : null}
                    projectContacts={project && project.project_contacts}
                    isLeftDividerHide={this.props.isLeftDividerHide}
                  />
                }
        {memberSelector}
        {this.props.type != 'summary-page' && this.createNavButtons()}
      </div>
    );   

    let dropDown = null;
    // TODO: make sure we have these classes
    switch (displayDropDown) {
    case 'mapDisplay':
      if (this.cachedDropDownDisplay) {
        dropDown = this.cachedDropDownDisplay;
      } else {
        this.cachedDropDownDisplay = dropDown = this.createMapDisplay(this.animate);
      }
      break;
    case 'inventoryDisplay':
      if (this.state.updateInventory) {
        this.cachedDropDownDisplay = dropDown = this.createInventoryDisplay(this.animate);
      }
      else if (this.cachedDropDownDisplay) {
        dropDown = this.cachedDropDownDisplay;
      }
      else {
        this.cachedDropDownDisplay = dropDown = this.createInventoryDisplay(this.animate);
      }
      break;
    default:
      break;
    }

    let waitSpinner = null;
    if (this.state.loader) {
      waitSpinner = <Home type="pdf" />;
    }

    let projectName;
    let canNavigateToProject = false;
    let projectId;
    if (project && project.name) {
      projectName = project.name;
      if (this.props.permissions.canEditProject) {
        canNavigateToProject = true;
      }
    } else {
      projectName = 'All Projects';
    }

    if (project && project.id) {
      projectId = project.id;
    }

    let delaysIcon;
    if (project && project.has_unread_alerts) {
      delaysIcon = <img
        className='delays-indicator'
        src={delaysActiveIcon}
        alt='project delays indicator'
        onClick={this.handleDelayDropdownDisplay}
        ref={e => { this.delayIndicator = e; }}
      />;
    }
    else if (project && (project.has_alerts || (project.has_delays && this.userCanViewAllDelays))) {
      delaysIcon = <img
        className='delays-indicator'
        src={delaysInactiveIcon}
        alt='project delays indicator'
        onClick={this.handleDelayDropdownDisplay}
        ref={e => { this.delayIndicator = e; }}
      />;
    }

    return (
      <div id={`project-header-${projectId}`} className={`project-header ${this.props.allProjects ? 'all-projects' : ''}`}>
        {addMemberPopup}
        <div className='column' style={{ flexDirection: isLeftDividerHide ? 'column' : 'row' }}>

          <div className="project-info" style={{ paddingTop: !isLeftDividerHide && '10px' }}>
            {
              project && project.is_favorite &&
              <div className="favorite" />
            }
            <div className="project-identity" style={{ marginBottom: isLeftDividerHide && '4px' }}>
              <div className='project-name-container'>
                <div className="project-name" title={projectName} onClick={canNavigateToProject ? this.handleNavigateToProject : null}>
                  {projectName}
                </div>
                {delaysIcon}
                {
                  delayDropdownDisplay &&
                  <DelaysDropDown
                    project={project}
                    dropDownFormat={this.state.delayDropdownDisplay}
                    closeDropDown={this.handleCloseDelayDropdownDisplay}
                    showDelaysList={!this.state.displayDelayId}
                    displayDelayId={this.state.displayDelayId}
                  />
                }
              </div>
              <div className='project-details'>
                <div className='details-ids'>
                  <div className="details-guid">
                    {project && project.guid ? 'ID: ' + project.guid : ''}
                  </div>
                  <div className="details-id">
                    {project && project.contract_id ? 'Contract ID: ' + project.contract_id : ''}
                  </div>
                </div>
                <div className="details-template">
                  { project && project.project_template && currentUserIsAdmin &&  <ProjectTemplateLink projectTypeId={project.project_type_id} projectTemplate={project.project_template} /> }
                </div>
              </div>
            </div>
          </div>
          {isLeftDividerHide ? (
            controls
            ) : (
              <React.Fragment>
                {!this.props.allProjects && project && !this.props.useSummaryDataOnly &&
                  <KeyMemberDisplay
                    project={project}
                    build={this.props.build}
                    displayedUserInfo={this.state.displayedUserInfo}
                    handleInfoOpen={this.handleInfoOpen}
                    handleInfoClose={this.handleInfoClose}
                    locationUsers={project && project.location ? project.location.location_users : null}
                    projectContacts={project && project.project_contacts}
                  />
                }
                {memberSelector}
                {this.props.type != 'summary-page' && this.createNavButtons()}
              </React.Fragment>
            )
          }
        </div>
        <div className='row'>
          {dropDown}
        </div>
        {waitSpinner}
        {this.state.showProgressReportModal && (
          <DateRangePickerModal
            title="Progress Report Date Range"
            onClose={this.handleCloseProgressReportModal}
            onGenerate={this.handleProgressReportGenerate}
            minStartDate={this.state.project && this.state.project.created_at}
          />
        )}
      </div>
    );
  }

}

const mapStateToProps = (state, ownProps) => {
  return {
    currentCompany: state.new_companies.currentCompany,
    currentUser: state.new_users.currentUser,
    permissions: state.new_users.permissions,
  };
};

export default withRouter(connect(mapStateToProps)(ProjectHeader));



// WEBPACK FOOTER //
// ./src/containers/TasksContainer/ProjectHeader/index.js